<template>
  	<EditDnsBatch />
</template>

<script>

// @ is an alias to /src
import EditDnsBatch from "../components/EditDnsBatch.vue";

export default {
  name: "EditDnsBatchs",
  components: {
    EditDnsBatch,
  },
};
</script>
